var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _ellipse, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTokenomicsListImage1764A5D27762096947Fc463F445Fdd078(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 145 93",
    style: {
      enableBackground: "new 0 0 145 93"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.58;fill:#1C2E9E;}\r\n\t.st1{opacity:0.24;fill:#1C2E9E;}\r\n\t.st2{opacity:0.88;fill:#1C2E9E;}\r\n\t.st3{fill:#1C2E9E;}\r\n\t.st4{opacity:0.69;fill:#1C2E9E;}\r\n\t.st5{opacity:0.54;fill:#1C2E9E;}\r\n\t.st6{fill:url(#SVGID_1_);fill-opacity:0.5;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.4,33.1L61.4,31l-2.1,2.1l2.1,2.1L63.4,33.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.8,46l-1.4-1.4L48.9,46l1.4,1.4L51.8,46z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.9,16.1l-1.2-1.2l-1.2,1.2l1.2,1.2L81.9,16.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M92.5,38.4l-1.2-1.2l-1.2,1.2l1.2,1.2L92.5,38.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.4,5l-1.2-1.2L21,5l1.2,1.2L23.4,5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M145,35.1l-3-3l-3,3l3,3L145,35.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M72.2,60.5l-2.3-2.3l-2.3,2.3l2.3,2.3L72.2,60.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M4.5,16.7l-2.3-2.3L0,16.7L2.3,19L4.5,16.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M57.2,87l-4.8-4.8L47.7,87l4.8,4.8L57.2,87z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M131,18.3l-1.7-1.7l-1.7,1.7l1.7,1.7L131,18.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M38.7,20.5l-0.6-0.6l-0.6,0.6l0.6,0.6L38.7,20.5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M117.5-0.6l-0.6-0.6l-0.6,0.6l0.6,0.6L117.5-0.6z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: -183.6129,
    cy: 291.1588,
    r: 1,
    gradientTransform: "matrix(-1.834931e-15 -29.9667 -30.0357 1.839156e-15 8815.0674 -5460.606)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1C2E9E",
      stopOpacity: 0.67
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C2E9E",
      stopOpacity: 0
    }
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st6",
    cx: 69.9,
    cy: 41.7,
    rx: 30,
    ry: 30
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M16.4,71.6V18.4H7.7V0.6H34v71H16.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M98.6,71.6V45.5h25.8l3.2,3.2v6.5l-3.2,3.2l3.2,3.2v6.5l-3.2,3.4H98.6z M121.2,55.3v-3.2H105v3.2H121.2z  M121.2,65.2v-3.2H105v3.2H121.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M60.4,53.9V18.4h43.9v23h17.6V9.5l-8.8-8.9H51.6l-8.8,8.9v53.2l8.8,8.9h42.9V53.9H60.4z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenomicsListImage1764A5D27762096947Fc463F445Fdd078);
export default __webpack_public_path__ + "static/media/tokenomics-list-image-1.764a5d27762096947fc463f445fdd078.0f49b1adf7085db045b63a132aac2e9c.svg";
export { ForwardRef as ReactComponent };